import React, { useEffect, useState } from 'react';
import {
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TableSortLabel,
  Typography,
} from '@material-ui/core';
import { Expandable } from '../../../components/Expandable';
import moment from 'moment';

const useStyles = makeStyles((theme) => ({
  tableContainer: {
    width: '100%',
    padding: theme.spacing(2),
  },
}));

const sortAscending = (updates) =>
  [...updates].sort(
    (a, b) => new Date(a.statusChangedAtUtc) - new Date(b.statusChangedAtUtc)
  );

const sortDescending = (updates) =>
  [...updates].sort(
    (a, b) => new Date(b.statusChangedAtUtc) - new Date(a.statusChangedAtUtc)
  );

const statusMap = {
  PENDING: 'Pending',
  STARTING: 'Starting',
  IN_PROGRESS: 'In Progress',
  COMPLETED: 'Completed',
  FAILED: 'Failed',
  INVALID_USERNAME_OR_PASSWORD: 'Invalid Username or Password',
  LOGIN_MFA_CODE_NEEDED: 'Login MFA Code Needed',
  ADD_PHONE_MFA_CODE_NEEDED: 'Add Phone MFA Code Needed',
  CREDENTIALS_CONFIRMED: 'Credentials Confirmed',
  CONFIRMING_MFA: 'Confirming MFA',
  INVALID_MFA_CODE: 'Invalid MFA Code',
  SAVING_FUTURE_CAPITAL_PHONE: 'Saving Future Capital Phone',
  FUTURE_CAPITAL_PHONE_SAVED: 'Future Capital Phone Saved',
  LOGGING_IN: 'Logging In',
  DOWNLOADING_FUND_LINEUP: 'Downloading Fund Lineup',
  FUND_LINEUP_DOWNLOADED: 'Fund Lineup Downloaded',
  SAVING_FACT_SHEETS: 'Saving Fact Sheets',
  FACT_SHEETS_SAVED: 'Fact Sheets Saved',
  UPDATING_FUND_LINEUP: 'Updating Fund Lineup',
  FUND_LINEUP_UPDATED: 'Fund Lineup Updated',
  STARTING_REBALANCE: 'Starting Rebalance',
  REBALANCE_COMPLETED: 'Rebalance Completed',
  STARTING_FUTURE_ELECTIONS: 'Starting Future Elections',
  FUTURE_ELECTIONS_COMPLETED: 'Future Elections Completed',
  SAVING_PLAYWRIGHT_TRACE: 'Saving Playwright Trace',
  PLAYWRIGHT_TRACE_SAVED: 'Playwright Trace Saved',
  WAITING_FOR_INSTRUCTION: 'Waiting for Instruction',
  INSTRUCTION_RECEIVED: 'Instruction Received',
};

export const AndromedaJobStatusUpdates = ({ data, loading, active }) => {
  const classes = useStyles();

  const [sortDirection, setSortDirection] = useState('asc');
  const [sortedData, setSortedData] = useState(data ?? []);

  const changeSorting = () => {
    var newDir = sortDirection === 'asc' ? 'desc' : 'asc';
    setSortDirection(newDir);
    setSortedData((prev) =>
      newDir === 'asc' ? sortAscending(prev) : sortDescending(prev)
    );
  };

  const rows = [
    {
      key: 'status',
      name: 'Status',
      formatter: (val) => statusMap[val] ?? val,
      align: 'left',
      sortable: false,
    },
    {
      key: 'statusChangedAtUtc',
      name: 'Timestamp',
      formatter: (val) =>
        moment.utc(val).local().format('MM/DD/YYYY, h:mm:ss a'),
      align: 'right',
      sortable: true,
    },
  ];

  useEffect(() => {
    if (data !== null) setSortedData(data ?? []);
  }, [data]);

  return (
    <Expandable
      defaultToOpen
      title="Status Updates"
      loading={loading}
      showLiveUpdates
      active={active}
    >
      <TableContainer className={classes.tableContainer}>
        <Table>
          <TableBody>
            <TableRow>
              {data !== null &&
                rows.map((row, idx) => (
                  <TableCell key={idx} align={row.align}>
                    {row.sortable ? (
                      <TableSortLabel
                        active={true}
                        direction={sortDirection}
                        onClick={changeSorting}
                      >
                        <Typography variant="body1">
                          <strong>{row.name}</strong>
                        </Typography>
                      </TableSortLabel>
                    ) : (
                      <Typography variant="body1">
                        <strong>{row.name}</strong>
                      </Typography>
                    )}
                  </TableCell>
                ))}
            </TableRow>
            {sortedData.map((update, idx) => (
              <TableRow key={idx}>
                {rows.map((row, idx2) => (
                  <TableCell key={idx2} align={row.align}>
                    <Typography variant="body2" color="textSecondary">
                      {row.formatter(update[row.key])}
                    </Typography>
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Expandable>
  );
};
